module.exports = __webpack_public_path__ + "img/result.66973d13.svg";